import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { CountryAndRegionsModule } from '@fgb/portal-component-library/src/lib/shared/country-and-regions';
import { TopUpAddressComponent } from './top-up-address.component';

@NgModule({
  declarations: [TopUpAddressComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CountryAndRegionsModule,
    NgbModule,
    FGBSharedModule
  ],
  exports: [TopUpAddressComponent],
})
export class TopUpAddressModule {}
